var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F7070",
    fillRule: "evenodd",
    d: "M.953.47a.66.66 0 0 1 .982 0L7 5.94 12.065.47a.66.66 0 0 1 .982 0 .793.793 0 0 1 0 1.06l-5.556 6a.66.66 0 0 1-.982 0l-5.556-6a.793.793 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;